import axios from "axios";
import {
  IGetMailConversationsParams,
  ISendMailMessageParams,
  ISendMailFilesParams,
  IGetMailStatsParams,
} from "../models/mail.model";

export const getMailConversations = async (
  params: IGetMailConversationsParams
) => {
  const res = await axios.get("/ai-channel/messages", {
    params: {
      channel: "EMAIL",
      page: params.page,
      limit: params.limit,
      keyword: params.keyword || "",
      status: params.status || "",
      ...(params.start_time ? { start_time: params.start_time } : {}),
      ...(params.campaign_id ? { campaign_id: params.campaign_id } : {}),
      ...(params.line_id ? { line_id: params.line_id } : {}),
    },
  });
  return res;
};

export const getMailConversationById = async (id: string) => {
  const res = await axios.get(`/ai-channel/${id}`);
  return res;
};

export const sendMailMessage = async (params: ISendMailMessageParams) => {
  const res = await axios.post("/ai-channel/messages", params);
  return res;
};

export const sendMailFiles = async (params: ISendMailFilesParams) => {
  const formData = new FormData();
  
  // Append multiple files with field name 'files'
  params.files.forEach((file) => {
    formData.append("files", file);
  });
  
  formData.append("to", params.to);
  formData.append("from", params.from);
  formData.append("conversation_id", params.conversation_id);

  const res = await axios.post("/ai-channel/files", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const updateMailConversationStatus = async (
  id: string,
  status: string
) => {
  const res = await axios.patch(`/ai-channel/${id}`, { status });
  return res;
};

export const getMailStats = async (params: IGetMailStatsParams) => {
  const res = await axios.get("/ai-channel/stats_details", {
    params: {
      start_time: params.start_time,
      start_date: params.start_date || params.start_time,
      channel: "EMAIL",
    },
  });
  return res;
};
